import { Stack } from "@mui/material";
import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
// Support for: annotations (e.g. links), text layer, in PDF.
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import { FileItem } from "@/common/fileItem";

// Docs:
// https://projects.wojtekmaj.pl/react-pdf/
// https://github.com/wojtekmaj/react-pdf
// https://github.com/wojtekmaj/react-pdf/wiki/Recipes

// Warning:
// The workerSrc must be set in the same module where you use React-PDF components (e.g., <Document>, <Page>).
// Setting it in a separate file like main.tsx and then importing React-PDF in another component may cause
// the default value to overwrite your custom setting due to module execution order.
// Always configure the worker in the file where you render the PDF components.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export interface PdfViewerProps {
  fileItem: FileItem;
  scale?: number;
}

export function PdfViewer({ fileItem, scale = 1 }: PdfViewerProps) {
  const [numPages, setNumPages] = useState<number | null>(null);
  // const [pageNumber, setPageNumber] = useState(1);

  // function changePage(offset: number) {
  //   setPageNumber((prevPageNumber) => prevPageNumber + offset);
  // }

  // function previousPage() {
  //   changePage(-1);
  // }

  // function nextPage() {
  //   changePage(1);
  // }

  return (
    <Stack direction='column' gap={1} sx={{ justifyContent: "flex-start", alignItems: "center" }}>
      <Stack direction='column' gap={1} sx={{ justifyContent: "flex-start", alignItems: "center" }}>
        <Document
          file={fileItem.fileUrl}
          // file={{ url: "https://ontheline.trincoll.edu/images/bookdown/sample-local-pdf.pdf" }}
          scale={scale}
          onLoadSuccess={(document) => {
            console.log("PDF.onLoadSuccess", document);
            setNumPages(document.numPages);
            // setPageNumber(1);
          }}
        >
          <Stack gap={2}>
            {Array.from(new Array(numPages), (_el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                // width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
                // height={600}
              />
            ))}
          </Stack>
        </Document>

        {/* PDF navigation (for single page view mode) */}
        {/* {!isNil(numPages) && (
          <Stack
            direction='row'
            gap={2}
            sx={{ width: "100%", justifyContent: "space-between", alignItems: "center" }}
          >
            <Box>
              Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </Box>

            {numPages >= 1 && (
              <Stack direction='row' gap={1}>
                <AppButton
                  variant='outlined'
                  size='small'
                  color='text'
                  disabled={pageNumber <= 1}
                  startIcon={<AppIcon of='chevronLeft' />}
                  onClick={previousPage}
                >
                  Previous
                </AppButton>

                <AppButton
                  variant='outlined'
                  size='small'
                  color='text'
                  disabled={pageNumber >= numPages}
                  endIcon={<AppIcon of='chevronRight' />}
                  onClick={nextPage}
                >
                  Next
                </AppButton>
              </Stack>
            )}
          </Stack>
        )} */}
      </Stack>
    </Stack>
  );
}
